import Spinner from 'react-bootstrap/Spinner';

export function Spiner() {
  return (
    <div className='container'>
        <Spinner animation="border" variant="warning" />
    </div>
    
    );
}